import { Directive, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[mustHaveNumber]',
    providers : [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => MustHaveNumberDirective), multi: true }
    ]
})
export class MustHaveNumberDirective {
    @Input('mustHaveNumber') validationNeeded : boolean;
    
    validator: Function;    
    
    constructor() { 
        this.validator = validateHasNumber
    }
    
    validate(control: UntypedFormControl) {
        return this.validationNeeded ? this.validator(control) : null
    }
    
}


export function validateHasNumber(control: UntypedFormControl) {
    let NUMBER_REGEX = new RegExp(/\d/)
    
    return NUMBER_REGEX.test(control.value) ? null : {
        mustHaveNumber: true
    };
}